/**
 * @desc 发布
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/quarter/publish',
    data,
  });
}

export function mock(data: defs.IdRequest): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/publish',
    data,
  });
}
